import {
  Card,
  CardBody,
  FormGroup,
  Input,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  Label,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import { NavLink } from "react-router-dom";
import { useState, React, useEffect, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import ReactTable from "components/ReactTable/ReactTable.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingOverlay from "react-loading-overlay";
import { MainContext } from "context/MainContext.js";
LoadingOverlay.propTypes = undefined;

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";

const TimezoneList = () => {
  const history = useHistory();
  const location = useLocation();
  const privileges = useContext(MainContext);

  const [errorMsg, setErrorMsg] = useState([]);
  const [showLoading, setShowLoading] = useState(false);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["devices.timezones.display"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }
  }, []);

  const redirectToDeviceDetails = (serialNumber) => {
    const location = {
      pathname: "/admin/devices/details",
      state: {
        value: serialNumber,
      },
    };
    history.push(location);
  };

  const openDevicePortal = (serialNumber) => {
    fetch("/api/v1/device/url", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
        serialNumber: serialNumber,
        virtuosoPort: window.location.port,
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        window.open(actualData.data.url, "_blank", "noreferrer");
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const handleDeviceCheckbox = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setSelectedDevices((selectedDevices) => [...selectedDevices, value]);
    } else {
      setSelectedDevices((device) => device.filter((v) => v !== value));
    }
  };

  const handleSelectAll = (e, data) => {
    const { checked } = e.target;
    if (checked) {
      setSelectAll(true);
      setSelectedDevices([]);
      setSelectedDevices(data.map((device) => device.serialNumber));
    } else {
      setSelectAll(false);
      setSelectedDevices([]);
    }
  };

  const columns = [
    {
      accessor: "selector",
      sortable: false,
      filterable: false,
      disableExport: true,
      flex: "0 1 5%",
      Header: (props) => {
        const userLevel = sessionStorage.getItem("privilegeLevel");
        if (
          userLevel >= 15 &&
          Utilities.validateLicense(
            sessionStorage.getItem("licenseTypes"),
            Utilities.LICENSE_PRO,
          )
        ) {
          return (
            <div style={{ paddingBottom: "8px" }}>
              <FormGroup check>
                <Label check>
                  <>
                    <Input
                      type="checkbox"
                      name="deviceAll"
                      onChange={(event) => handleSelectAll(event, props.data)}
                      checked={selectAll}
                    />
                    <span className="form-check-sign" />
                  </>
                </Label>
              </FormGroup>
            </div>
          );
        } else {
          return (
            <div style={{ paddingLeft: "8px", paddingBottom: "8px" }}></div>
          );
        }
      },
      Cell: (props) => {
        const userLevel = sessionStorage.getItem("privilegeLevel");
        if (
          userLevel >= 15 &&
          Utilities.validateLicense(
            sessionStorage.getItem("licenseTypes"),
            Utilities.LICENSE_PRO,
          )
        ) {
          return (
            <div style={{ paddingLeft: "7px", paddingBottom: "7px" }}>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    value={props.row.original.serialNumber}
                    checked={selectedDevices.includes(
                      props.row.original.serialNumber,
                    )}
                    onChange={handleDeviceCheckbox}
                  />
                  <span className="form-check-sign" />
                </Label>
              </FormGroup>
            </div>
          );
        } else {
          <div style={{ paddingLeft: "7px", paddingBottom: "7px" }}></div>;
        }
      },
    },
    {
      Header: "System Name",
      accessor: "systemName",
      sortBy: "name",
      flex: "1 1 0",
    },
    {
      Header: "Serial Number",
      accessor: "serialNumber",
      sortBy: "serialNumber",
      flex: "1 1 0",
    },
    {
      Header: "GAM IP Address",
      accessor: "ipAddress",
      sortBy: "ipAddress",
      flex: "1 1 0",
    },
    {
      Header: "NTP Server 1",
      accessor: "ntpServer1",
      sortBy: "ntpServer1",
      Cell: (props) => {
        return <div style={{ whiteSpace: "pre-line" }}>{props.value}</div>;
      },
      flex: "1 1 0",
    },
    {
      Header: "NTP Server 2",
      accessor: "ntpServer2",
      sortBy: "ntpServer2",
      Cell: (props) => {
        return <div style={{ whiteSpace: "pre-line" }}>{props.value}</div>;
      },
      flex: "1 1 0",
      show: false,
    },
    {
      Header: "NTP Server 3",
      accessor: "ntpServer3",
      sortBy: "ntpServer3",
      Cell: (props) => {
        return <div style={{ whiteSpace: "pre-line" }}>{props.value}</div>;
      },
      flex: "1 1 0",
      show: false,
    },
    {
      Header: "NTP Server 4",
      accessor: "ntpServer4",
      sortBy: "ntpServer4",
      Cell: (props) => {
        return <div style={{ whiteSpace: "pre-line" }}>{props.value}</div>;
      },
      flex: "1 1 0",
      show: false,
    },
    {
      Header: "NTP Server 5",
      accessor: "ntpServer5",
      sortBy: "ntpServer5",
      Cell: (props) => {
        return <div style={{ whiteSpace: "pre-line" }}>{props.value}</div>;
      },
      flex: "1 1 0",
      show: false,
    },
    {
      Header: "Timezone",
      accessor: "timezone",
      flex: "1 1 0",
    },
    {
      Header: "Summer Time",
      accessor: "summertime",
      Cell: (props) => {
        return <div style={{ whiteSpace: "pre-line" }}>{props.value}</div>;
      },
      flex: "1 1 0",
    },
    {
      Header: "Offset",
      accessor: "offset",
      flex: "1 1 0",
    },
    {
      Header: "",
      accessor: "actions",
      Cell: (props) => {
        return (
          <UncontrolledDropdown direction="down">
            <DropdownToggle
              caret
              color="info"
              style={{
                padding: "6px 14px 6px 14px",
                margin: "0px",
              }}
            >
              Actions
            </DropdownToggle>
            <DropdownMenu container={"body"}>
              <DropdownItem
                onClick={() =>
                  redirectToDeviceDetails(props.row.original.serialNumber)
                }
              >
                View GAM Details
              </DropdownItem>
              {sessionStorage
                .getItem("permissions")
                .includes("GAM_PORTAL_ACCESS") ? (
                <>
                  <DropdownItem divider />
                  <DropdownItem
                    onClick={() =>
                      openDevicePortal(props.row.original.serialNumber)
                    }
                  >
                    Open GAM Portal
                  </DropdownItem>
                </>
              ) : (
                ""
              )}
            </DropdownMenu>
          </UncontrolledDropdown>
        );
      },
      flex: "1 1 0",
      padding: "0px",
      sortable: false,
      filterable: false,
    },
  ];

  return (
    <>
      <ToastContainer />
      <div className="content">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />

        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/dashboard",
                      }}
                    >
                      <FontAwesomeIcon icon={faHome} />
                    </NavLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem>Timezones</BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                {errorMsg.length > 0 ? (
                  <div
                    style={{
                      backgroundColor: "#FFC0A4",
                      border: "1px solid #ef8157",
                      color: "#66615b",
                      paddingTop: "15px",
                      marginBottom: "15px",
                    }}
                  >
                    <ul>
                      {errorMsg.map((d, index) => (
                        <li key={index}>{d}</li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  ""
                )}
                <Row>
                  <Col>
                    <ReactTable
                      query="/api/v1/timezones/list"
                      columns={columns}
                      title="Device Timezones"
                      className="-striped -highlight primary-pagination"
                      submethodParam={selectedDevices}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default TimezoneList;
